import Testimonials from "../class/Testimonials";
import Parallax from '../class/Parallax';


new Parallax('.everything-you-need-parallax',{});

new Testimonials('.testimonials-slider').init();
